// components/AgentDescription.jsx
// Renders Tiptap-generated HTML from agent.description[lang].
// Accepts an optional wrapperStyle prop to apply font-size / color / line-height
// from the agentPageLayout config (threaded in from AgentPageRenderer).
// Uses a scoped CSS class to avoid polluting global prose styles.

'use client'

export default function AgentDescription({ html, wrapperStyle = {} }) {
  if (!html) return null

  return (
    <>
      <style>{`
        .agent-desc p          { margin: 0 0 0.6em; }
        .agent-desc p:last-child { margin-bottom: 0; }
        .agent-desc h1,
        .agent-desc h2,
        .agent-desc h3         { font-weight: 700; margin: 0.75em 0 0.4em; line-height: 1.25; color: var(--color-main); }
        .agent-desc h1         { font-size: 1.25em; }
        .agent-desc h2         { font-size: 1.1em; }
        .agent-desc h3         { font-size: 1em; }
        .agent-desc ul,
        .agent-desc ol         { padding-left: 1.25em; margin: 0.5em 0; }
        .agent-desc li         { margin-bottom: 0.25em; }
        .agent-desc a          { color: var(--color-main); text-decoration: underline; }
        .agent-desc a:hover    { opacity: 0.8; }
        .agent-desc strong     { font-weight: 700; }
        .agent-desc em         { font-style: italic; }
        .agent-desc u          { text-decoration: underline; }
        .agent-desc s          { text-decoration: line-through; }
        .agent-desc blockquote {
          border-left: 3px solid var(--color-main);
          padding-left: 0.75em;
          margin: 0.5em 0;
          opacity: 0.8;
          font-style: italic;
        }
      `}</style>
      <div
        className="agent-desc"
        style={wrapperStyle}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  )
}